export default "__VITE_ASSET__cb37d686__"